import React, { Component } from 'react';
import classNames from 'classnames';
import { PropTypes } from 'prop-types';
import { SvgImage} from '.';
import { VectorRightIconNew, arrowRightIcon } from '../../style/images';
import { Box, Tabs, Tab } from '@mui/material';
import { connect } from 'react-redux';
import { hierarchyNodeActions } from '../services';
import { currentNodeState } from '../store';

export class TreeViewComponent extends Component {
  constructor( props ) {
    super( props );

    this.state = {
      expanded: props.defaultState || false,
    };
  }

  toggleExpanded = () => {
    const { collapsible } = this.props;
    if ( !collapsible ) {
      return;
    }
    const { expanded } = this.state;
    // if(!expanded){
    //   let current = this.props.data
    //   if(this.props.mobileParentTreeView&&current.name!=="Categories"){
    //     this.props.setNode(current)
    //   }
    // }
    this.setState( { expanded: !expanded } );
  }

  handleSelectionChanged = () => {
    const { onSelected = () => {}, data } = this.props;
    onSelected( data );
  }

  handleNodeChange = (event, newValue)=>{
    this.setState({currentNode:newValue})
  }
  render() {
    const { childProperty, collapsible = true, data, depth = -1, isActive, itemTemplate, width, border, currentNode, dispatch } = this.props;
    const { expanded } = this.state;
    let current = data;
    let children = current[childProperty] || [];
    const hasChildren = children.length > 0;
    const className = classNames( 'tree-view', { 
      'active': currentNode.name === current.name, 
      'expanded': collapsible && expanded, 
      'collapsed': collapsible && !expanded,
    } );

    const childClassName = classNames(`tree-node depth-${depth}`,{
      'childNodes': depth>0,
      'expanded': collapsible && expanded,
      'mainNodes': depth===0
    })
    const childTrees = ( expanded || !current.parent ) && hasChildren && children.map( ( item, key ) => 
      <TreeView key={ key } { ...this.props} data={ item } expanded={expanded} overflowY="none" border="1px solid #EBEBEB" mt="0px" collapsible depth={ depth + 1 }/> 
      // <Tab key={key} label={item.name}></Tab>
    );

    const widthStyle = depth === -1 ? { width: `${width}px`, minWidth: `${width}px` } : null;
    
    return (
      <Box sx={{mt:this.props.mt, height:"100%", width:"100%", display:{xl:"flex", md:"flex", sm:"flex", xs:"flex"}, flexDirection:"column", overflowY:this.props.overflowY}}>
        <div className={ className } id="treeView">
          { collapsible && 
            <div className={ childClassName }>
              { itemTemplate( { ...current, handleSelectionChanged: this.handleSelectionChanged } ) }
              { hasChildren && <SvgImage
                source={ VectorRightIconNew } 
                className={ classNames( 'expander', { 'expanded': expanded } ) } 
                onClick={ this.toggleExpanded }
              /> 
              }
            </div>
          }
          { childTrees }
        </div>
      </Box>
    );
    // return (<Box sx={{height:"100%", width:"100%", display:{xl:"flex", md:"flex", sm:"none"}}}>
    //   <Tabs 
    //     orientation="vertical"
    //     variant="scrollable"
    //     value={this.state.currentNode}
    //     onChange={this.handleNodeChange}
    //     aria-label="Vertical tabs example"
    //     sx={{ borderRight: 1, borderColor: 'divider' }}>
    //       { childTrees }
    //   </Tabs>
    // </Box>)
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
        setNode:(current)=>dispatch( { type: hierarchyNodeActions.SETNODE, node: current } )
  }
}

TreeViewComponent.propTypes = {
  childProperty: PropTypes.string,
  collapsible: PropTypes.bool,
  data: PropTypes.shape( {
    name: PropTypes.string.required,
    children: PropTypes.arrayOf( PropTypes.object ),
    isConfigurator: PropTypes.bool.required,
    isSelector: PropTypes.bool.required,
    isEnabled: PropTypes.bool.required,
    isCategoryNode: PropTypes.bool.required
  } ),
  defaultState: PropTypes.bool,
  depth: PropTypes.number,
  isActive: PropTypes.func.isRequired,
  itemTemplate: PropTypes.func,
  onSelected: PropTypes.func,
  width: PropTypes.number,
  mapDispatchToProps: PropTypes.func.isRequired
};

export const TreeView = connect(currentNodeState, mapDispatchToProps)(TreeViewComponent);